{
  "account_is_inactive": "Ihr Konto ist inaktiv.",
  "analytics_chart_frequency_d": "Täglich",
  "analytics_chart_frequency_h": "Stündlich",
  "analytics_chart_frequency_m": "Monatlich",
  "analytics_chart_frequency_w": "Wöchentlich",
  "analytics_charts": "Diagramme",
  "analytics_date": "Datum",
  "analytics_description_empty": "Keine Daten für den ausgewählten Zeitraum vorhanden.",
  "emailvalidator_validate_freecredits_used": "Folgende kostenlose Credits werden verwendet:",
  "analytics_event_bounce": "Unzustellbar",
  "analytics_event_clicks": "Geklickt",
  "analytics_event_delivered": "Zugestellt",
  "analytics_event_drop": "Abgelehnt",
  "analytics_event_opens": "Geöffnet",
  "analytics_event_queued": "Warteschlange",
  "analytics_event_sent": "Zugestellt",
  "analytics_event_spam": "Spam",
  "analytics_event_unsubscribes": "Abgemeldet",
  "analytics_events": "Events",
  "analytics_events_all": "Alle",
  "analytics_events_bounce": "Unzustellbar",
  "analytics_events_bounce_tooltip": "Prozentsatz und Anzahl der E-Mails, die von den Kundenservern zurückgewiesen wurden.",
  "analytics_events_bounces": "Bounces",
  "analytics_events_clicks": "Klicks",
  "analytics_events_clicks_tooltip": "Prozentsatz und Anzahl der Personen, die mindestens auf einen Link in Ihrer Nachricht geklickt haben.",
  "analytics_events_delivered": "Zugestellt",
  "analytics_events_delivered_tooltip": "Prozentsatz und Anzahl der gesendeten Nachrichten die erfolgreich zugestellt wurden.",
  "analytics_events_drop": "Abgelehnt",
  "analytics_events_drop_tooltip": "Diese E-Mails wurden entfernt, weil sie zuvor Abmeldungen, Bounce- oder Spam-Meldungen generiert haben. Abgelehnte E-Mails werden im Abschnitt \"Unterdrückungen\" angezeigt",
  "analytics_events_opens": "Geöffnet",
  "analytics_events_opens_tooltip": "Prozentsatz und Anzahl der E-Mails, die von Ihren Empfängern geöffnet wurden.",
  "analytics_events_queued": "Warteschlange",
  "analytics_events_queued_tooltip": "Prozentsatz der gesamten E-Mails die sich noch in der Warteschlange für den Versand befinden.",
  "analytics_events_sent": "Zugestellt",
  "analytics_events_spam": "Spam",
  "analytics_events_spam_tooltip": "Prozentsatz der Empfänger die Ihre zugestellte Nachricht als Spam gemeldet haben.",
  "analytics_events_unsubscribes": "Abmeldungen",
  "analytics_events_unsubscribes_tooltip": "Prozentsatz der Abmeldungsanfragen die aus erfolgreich zugestellten E-Mails resultieren.",
  "analytics_file": "Dateiname",
  "analytics_filterby_domain": "Domain",
  "analytics_filterby_recipient": "Empfänger",
  "analytics_filterby_sender": "Absender",
  "analytics_filterby_subject": "Betreff",
  "analytics_overview": "Übersicht",
  "analytics_recipient": "Empfänger",
  "analytics_sender": "Absender",
  "analytics_status": "Status",
  "analytics_subject": "Betreff",
  "analytics_temporary_error": "Ein temporärer Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  "analytics_title": "Analytik",
  "analytics_total_emails": "Hochgeladene E-Mails",
  "analytics_total_processed": "Verarbeitete E-Mails",
  "analytics_upload_date": "Datum des Uploads",
  "and": "und",
  "annually": "Jährlich",
  "authentication_expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "billing_changepassword_description": "Ändern Sie Ihr Passwort in diesem Bereich. Dieses Passwort wird nur für den Zugriff auf das Dashboard verwendet.",
  "billing_changepassword_title": "Passwort ändern",
  "billing_contact_were_not_found": "Rechnungskontakt wurde nicht gefunden.",
  "billing_contacts_address": "Adresse",
  "billing_contacts_address2": "Adresse 2",
  "billing_contacts_billing": "Rechnungs-E-Mails - Rechnungen und Rechnungserinnerungen",
  "billing_contacts_button_add": "Hinzufügen",
  "billing_contacts_button_edit": "Bearbeiten",
  "billing_contacts_city": "Stadt",
  "billing_contacts_company": "Firmenname",
  "billing_contacts_country": "Land",
  "billing_contacts_editcontact": "Kontakt bearbeiten",
  "billing_contacts_email": "E-Mail Adresse",
  "billing_contacts_empty": "E-Mails werden an die Adresse in Ihrem Hauptkonto gesendet. Geben Sie weitere Adressen ein, um Mitteilungen an zusätzliche Empfänger zu senden.",
  "billing_contacts_firstname": "Vorname",
  "billing_contacts_lastname": "Nachname",
  "billing_contacts_marketing": "Service-E-Mails - Verlängerungsmitteilungen, Registrierungsbestätigungen usw.",
  "billing_contacts_phone": "Telefonnummer",
  "billing_contacts_products": "Produkt-E-Mails - Bestelldetails, Willkommens-E-Mails usw.",
  "billing_contacts_slide_description": "E-Mails werden an die Adresse in Ihrem Hauptkonto gesendet. Geben Sie weitere Adressen ein, um Mitteilungen an zusätzliche Empfänger zu senden.",
  "billing_contacts_slide_title": "Neuen Kontakt hinzufügen",
  "billing_contacts_stateregion": "Bundesland/Region/Provinz",
  "billing_contacts_subscriptions": "Abonnements",
  "billing_contacts_support": "Support-E-Mails - Erlauben Sie diesem Benutzer, Tickets in Ihrem Konto zu öffnen.",
  "billing_contacts_terms": "Ich habe die Datenschutzbestimmungen und die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie.",
  "billing_contacts_title": "Kontakte hinzufügen",
  "billing_contacts_transactional": "Allgemeine E-Mails - Allgemeine Ankündigungen & Passwort-Erinnerungen",
  "billing_contacts_zip": "Postleitzahl",
  "billing_details_contact_above": "Nur an den Standardkontakt senden",
  "billing_emails_sentdate": "Absendedatum",
  "billing_emails_subject": "Betreff",
  "billing_invoice_date": "Absendedatum",
  "billing_invoice_duedate": "Fälligkeitsdatum",
  "billing_invoice_number": "Nummer",
  "billing_invoice_status": "Status",
  "billing_invoice_status_cancelled": "Abgebrochen",
  "billing_invoice_status_paid": "Bezahlt",
  "billing_invoice_status_refunded": "Zurückerstattet",
  "billing_invoice_status_unpaid": "Unbezahlt",
  "billing_invoice_total": "Gesamt",
  "billing_product_payment_method_banktransfer": "Banküberweisung",
  "billing_product_paymentmethod_avangate": "Kreditkarte (2Checkout)",
  "billing_product_paymentmethod_stripe": "Kreditkarte (Stripe)",
  "button_add_contact": "Kontakt hinzufügen",
  "button_add_filter": "Filter hinzufügen",
  "button_add_plan": "Einen neuen Tarifplan bestellen",
  "button_add_subaccount": "Unterkonto hinzufügen",
  "button_add_suppression": "Unterdrückung hinzufügen",
  "button_add_template": "Vorlage hinzufügen",
  "button_addbcc": "BCC hinzufügen",
  "button_addfooter": "Fußzeile hinzufügen",
  "button_advanced_search": "Erweiterte Suche",
  "button_apply": "Anwenden",
  "button_back": "Zurück",
  "button_basic_search": "Einfache Suche",
  "button_buycredits": "Credits kaufen",
  "button_cancel": "Abbrechen",
  "button_close": "Schließen",
  "button_contact_us": "kontaktiere uns",
  "button_create": "Erstellen",
  "button_createalert": "Warnhinweis erstellen",
  "button_delete": "Löschen",
  "button_delete_all": "Alle löschen",
  "button_delete_filtered": "Gefilterte löschen",
  "button_delete_selected": "Ausgewählte löschen ({n})",
  "button_edit": "Bearbeiten",
  "button_export": "Exportieren",
  "button_import": "Datei importieren",
  "button_limits": "Grenzen setzen",
  "button_more": "Mehr",
  "button_next": "Weiter",
  "button_refresh": "Aktualisieren",
  "button_request_cancellation": "Stornierung beantragen",
  "button_reset": "Zurücksetzen",
  "button_returnlist": "Zurück zur Liste",
  "button_save": "Speichern",
  "button_search": "Suche",
  "button_select_fromdevice": "Dateien von Ihrem Gerät auswählen",
  "button_unsubscribe": "Abmeldelink hinzufügen",
  "button_update": "Aktualisieren",
  "button_update_template": "Vorlage aktualisieren",
  "button_update_unsubscribe": "Abmeldelink aktualisieren",
  "button_updatealert": "Warnhinweis aktualisieren",
  "button_updatebcc": "BCC aktualisieren",
  "button_updatefooter": "Fußzeile aktualisieren",
  "confirm_password_is_missing": "Passwort bestätigen ist obligatorisch.",
  "dashboard_clicked": "Geklickt",
  "dashboard_delivered": "Zugestellt",
  "dashboard_emails_sent": "E-Mails gesamt",
  "dashboard_emails_sent_out_of": "Gesendete E-Mails von",
  "dashboard_gotoanalytics": "Zu Analytics gehen",
  "dashboard_new_version": "Eine aktualisierte Version ist verfügbar!",
  "dashboard_new_version_cancel": "OK",
  "dashboard_new_version_description": "Speichern Sie Ihre Arbeit und laden Sie die Seite neu,<br> oder drücken Sie \"Jetzt aktualisieren\", um eine neue Version zu laden.",
  "dashboard_new_version_ok": "Jetzt aktualisieren",
  "dashboard_plan_emails": "E-Mails .",
  "dashboard_plan_label": "Plan",
  "dashboard_plan_label_interval": "{interval} Plan",
  "dashboard_plan_limit_unit_daily": "Tag",
  "dashboard_plan_limit_unit_monthly": "Monat",
  "dashboard_plan_limit_unit_yearly": "Jahr",
  "dashboard_recent_email_activities": "Letzte E-Mail-Aktivitäten",
  "dashboard_try": "Sie verwenden eine \"kostenlose Testversion\". Zur Anzeige des vollständigen Dashboards:",
  "datepicker_last_3_months": "Letzte 3 Monate",
  "datepicker_last_30days": "Letzte 30 Tage",
  "datepicker_last_month": "Letzter Monat",
  "datepicker_last_sevendays": "Letzte 7 Tage",
  "datepicker_last_week": "Letzte Woche",
  "datepicker_last_year": "Letztes Jahr",
  "datepicker_this_month": "Dieser Monat",
  "datepicker_this_year": "Dieses Jahr",
  "datepicker_today": "Heute",
  "datepicker_yesterday": "Gestern",
  "delete_all_bounce": "Alle Bounces löschen",
  "delete_all_manual": "Alle Manuals löschen",
  "delete_all_spam": "Alle Spams löschen",
  "delete_all_unsubscribe": "Alle Abmeldungen löschen",
  "delete_fist_login_dont": "Diese Nachricht nicht mehr anzeigen.",
  "delete_fist_login_one": "<h3>Willkommen im turboSMTP Advanced Dashboard.</h3><p>Sehen Sie Echtzeit-Statistiken über Ihre E-Mail-Kampagnen<br>und verbessern Sie Ihre Ergebnisse mit professionellen Tools.</p><h4>Bitte folgen Sie den Anweisungen zur Konfiguration Ihres Panels.</h4>",
  "delete_fist_login_three_a": "Bitte geben Sie den Namen des SMTP-Servers in Ihren Mail-Client ein.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "Bitte vergessen Sie nicht, die DNS-Einträge Ihrer Domain zu konfigurieren <br>Die Parameter finden Sie in Ihren \"Einstellungen\".",
  "delete_fist_login_two_a": "<h3>Open Tracking</h3><p>Mit turboSMTP können Sie die Öffnungsrate Ihrer Nachrichten verfolgen.</p>",
  "delete_fist_login_two_b": "<h3>Click Tracking</h3><p>Mit turboSMTP können Sie die Klickraten Ihrer Nachrichten verfolgen.</p>",
  "editor_quill_button_title": "HTML-Quelle anzeigen",
  "editor_quill_cancel_text": "Abbrechen",
  "editor_quill_msg": "Inhalt im HTML-Format bearbeiten",
  "editor_quill_ok_text": "Ok",
  "emails_month": "E-Mails/Monat",
  "emailvalidator_add_file": "Datei hinzufügen",
  "emailvalidator_add_form_errors": "Formularfehler",
  "emailvalidator_add_form_nofile_selected": "Keine Datei ausgewählt",
  "emailvalidator_add_value": "Hinzufügen zwischen",
  "emailvalidator_attention": "Achtung!",
  "emailvalidator_available": "Gratisguthaben",
  "emailvalidator_balance_description": "Ihr Guthaben ist",
  "emailvalidator_balance_title": "Ihr Validierungsguthaben",
  "emailvalidator_buy_extra_credit": "Extra-Guthaben kaufen",
  "emailvalidator_complete": "Ausfüllen",
  "emailvalidator_confirm_delete_label": "Vorgang bestätigen",
  "emailvalidator_confirm_delete_text": "Möchten Sie diese Liste wirklich löschen?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">Contact support <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "Kosten pro E-Mail sind",
  "emailvalidator_date": "Erstellungsdatum:",
  "emailvalidator_day": "Tag",
  "emailvalidator_details_empty": "Keine Elemente enthalten",
  "emailvalidator_domain": "Domain",
  "emailvalidator_domain_age": "Domain-Alter",
  "emailvalidator_email": "E-Mail",
  "emailvalidator_email_addesses": "E-Mail-Adressen",
  "emailvalidator_empty": "Eine hochgeladene Datei darf in jeder Zeile nur eine E-Mail-Adresse enthalten. Zulässige Dateiformate sind csv und txt. Oder wählen Sie eine Datei zum Hochladen aus.",
  "emailvalidator_entry_details": "Validierungsdetails",
  "emailvalidator_error": "Fehler",
  "emailvalidator_error_contact_support": "Fehler: Bitte kontaktieren Sie den Support!",
  "emailvalidator_expiring": "Ablauf am",
  "emailvalidator_export": "Export",
  "emailvalidator_free_email": "Gratis E-Mail",
  "emailvalidator_how_many": "Wie viele E-Mails möchten Sie validieren?",
  "emailvalidator_list_contains": "Die hochgeladene Liste enthält",
  "emailvalidator_list_not_removed": "Fehler beim Entfernen der Liste",
  "emailvalidator_list_removed": "Die Liste wurde erfolgreich entfernt.",
  "emailvalidator_mx_record": "MX-Eintrag",
  "emailvalidator_please_enter_amout": "Bitte geben Sie den Betrag ein, den Sie in Ihr virtuelles Wallet einzahlen möchten.",
  "emailvalidator_price_calculator": "Preis-Kalkulator",
  "emailvalidator_price_email": "Preis pro E-Mail",
  "emailvalidator_process_now": "Jetzt bearbeiten",
  "emailvalidator_refresh": "Aktualisieren",
  "emailvalidator_slide_description": "Die Datei muss aus einer Spalte bestehen und alle E-Mail-Adressen enthalten, die Sie importieren möchten.",
  "emailvalidator_slide_details_description": "Zulässige Dateiformate sind csv oder txt.",
  "emailvalidator_slide_details_title": "Datei hierher ziehen und einfügen",
  "emailvalidator_slide_manually_description": "Kopieren Sie mehrere E-Mail-Adressen und fügen Sie diese durch eine Endzeile getrennt in das Feld unten ein.",
  "emailvalidator_slide_manually_title": "Manuell hinzufügen",
  "emailvalidator_smpt_provider": "SMTP-Provider",
  "emailvalidator_status": "Status",
  "emailvalidator_status_abuse": "Missbrauch",
  "emailvalidator_status_catch_all": "Catch-All",
  "emailvalidator_status_do_not_mail": "Nicht senden",
  "emailvalidator_status_invalid": "Ungültig",
  "emailvalidator_status_spamtrap": "Spam",
  "emailvalidator_status_unknown": "Unbekannt",
  "emailvalidator_status_valid": "Gültig",
  "emailvalidator_title": "E-Mail-Validator",
  "emailvalidator_total_cost": "Gesamtkosten sind",
  "emailvalidator_upload_warning": "Ihr aktuelles Guthaben beträgt {aktuelles_Guthaben} Sie müssen {benötigtes_Guthaben} an zusätzlichem Guthaben erwerben, um diese Liste zu validieren...",
  "emailvalidator_validate_list": "Liste validieren",
  "emailvalidator_validate_now": "Jetzt validieren",
  "emailvalidator_validated_lists": "Validierte Listen",
  "emailvalidator_validation_date": "Validierungsdatum",
  "emailvalidator_value": "Wert",
  "emailvalidator_you_have": "Sie haben",
  "empty_authorization_token": "Autorisierungs-Token fehlt",
  "empty_request_body": "Anfrage ist unvollständig",
  "error": "Fehler",
  "file_too_large": "Datei_zu_groß",
  "filter": "Filter",
  "filter_by": "Filtern nach",
  "filter_fuzzy": "Smart-Search",
  "filter_fuzzy_description": "Aktivieren Sie diese Funktion, um ähnliche Einträge wie den Suchbegriff zu finden.",
  "filter_placeholder_analytics": "Suchen...",
  "filter_placeholder_suppressions": "Suchen...",
  "filters_show": "Filter anzeigen",
  "filters_hide": "Filter ausblenden",
  "filter_suppressions_placeholder": "Suchen Sie nach Empfänger, Absender, E-Mail-Betreff oder Grund für die Unterdrückung.",
  "first_login_step": "Schritt {n}",
  "forgot_password_changed": "Ihr Passwort wurde erfolgreich geändert.",
  "forgot_password_click": "Klicken Sie hier",
  "forgot_password_confirm": "Passwort bestätigen",
  "forgot_password_done": "Erledigt!",
  "forgot_password_donot_match": "Die Passwörter stimmen nicht überein.",
  "forgot_password_email_not_found": "E-Mail-Adresse nicht gefunden",
  "forgot_password_enter_email": "Geben Sie Ihre E-Mail-Adresse ein",
  "forgot_password_error": "Beim Ändern Ihres Passworts ist ein Fehler aufgetreten.",
  "forgot_password_expired": "Die E-Mail zum Zurücksetzen Ihres Passworts ist abgelaufen.",
  "forgot_password_pick": "Wählen Sie ein Passwort",
  "forgot_password_please_reset": "Bitte wählen Sie Ihr Passwort",
  "forgot_password_recovery_email_sent": "Die Wiederherstellungs-E-Mail wurde gesendet",
  "forgot_password_resend": "um die E-Mail erneut zu senden.",
  "forgot_password_reset": "Passwort zurücksetzen",
  "forgot_password_send_password_reset_link": "Passwort-Reset-Link senden",
  "forgot_password_sent_email_to_update_password": "Wir haben Ihnen soeben eine E-Mail mit einem Link zur Aktualisierung Ihres Passworts gesendet.",
  "forgot_password_set": "Neues Passwort festlegen",
  "forgot_password_should_have": "Passwort sollte bestehen aus:",
  "forgot_password_suggestions": "<li>Mindestens einem Kleinbuchstaben</li> <li>Mindestens einem Großbuchstaben</li><li>Mindestens einer Zahl</li><li>Mindestens 10 Zeichen</li>",
  "forgot_password_switch": "Zum Login wechseln",
  "forgot_password_switch_to_login": "Zum Login wechseln",
  "forgot_password_token_is_missing": "Vergessenes Passwort-Token fehlt",
  "forgot_password_unable_to_send": "E-Mail kann nicht gesendet werden.",
  "forgot_password_username": "Benutzername E-Mail",
  "forgot_password_we_will_send_you": "Wir senden Ihnen einen Link zur Wiederherstellung des Passworts.",
  "free_account": "Gratis Konto",
  "friday": "Freitag",
  "fuzzy_tooltip": "Aktivieren Sie diese Funktion, um Artikel zu finden, die dem Suchbegriff ähnlich sind",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "Interner Serverfehler aufgetreten. Bitte versuchen Sie es später erneut.",
  "invalid_authorization_token": "Autorisierungs-Token ist ungültig",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "Der Grenzwert muss mindestens 1 sein",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "Der Seitenwert muss mindestens 1 sein",
  "invalid_value_for_orderby_parameter": "Der Parameter \"Sortieren nach\" ist ungültig.",
  "invalid_value_for_the_parameter_type": "Ungültiger Wert für den Parametertyp",
  "invoice_not_found": "Rechnung nicht gefunden",
  "jwt_error_full_details": "Vollständige Details",
  "jwt_error_status": "HTTP-Status",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "Die folgende URL existiert nicht",
  "l_dont_have_account": "Sie haben noch kein Konto?",
  "l_email_address": "E-Mail Adresse",
  "l_forgot_password": "Passwort vergessen?",
  "l_login": "Anmeldung",
  "l_password": "Passwort",
  "l_remember_me": "Eingeloggt bleiben.",
  "l_sign_up_here": "Registrieren Sie sich hier",
  "l_username_email": "Benutzername E-Mail",
  "l_welcome_back": "Willkommen zurück",
  "language_changed_label": "Sie haben die Sprache geändert",
  "language_changed_message": "Um die Sprachänderungen zu übernehmen, laden Sie die Seite neu",
  "language_changed_reload": "neu laden",
  "m_accountinfo": "Kontoinformationen",
  "m_analytics": "Analytik",
  "m_billing": "Proforma-Rechnungen",
  "m_dashboard": "Dashboard",
  "m_emailsentout": "Versendete E-Mails",
  "m_emailvalidator": "E-Mail-Validator",
  "m_messages": "System-Meldungen",
  "m_myaccount": "Mein Konto",
  "m_mydetails": "Mein Konto",
  "m_noplans": "Keine Pläne",
  "m_of": "von",
  "m_products": "Meine Produkte",
  "m_savechanges": "Änderungen speichern",
  "m_settings": "Einstellungen",
  "m_subaccounts": "Unterkonten",
  "m_suppressions": "Unterdrückungen",
  "m_tickets": "Meine Tickets",
  "m_validuntil": "Gültig bis",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "Fehlender oder ungültiger Wert für die WhiteLabeled-Variable",
  "missing_required_parameter": "Ein erforderlicher Parameter fehlt",
  "missing_required_parameter_email": "E-Mail fehlt",
  "missing_required_parameter_from": "Die 'Von'-Angaben fehlen",
  "missing_required_parameter_to": "Die 'An'-Angaben fehlen",
  "missing_required_parameter_tz": "Die 'tz'-Angaben fehlen",
  "modal_confirmation": "Bestätigung",
  "monday": "Montag",
  "monthly": "Monatlich",
  "my_account_title": "Mein Konto",
  "myaccount_2fa_title": "Zwei-Faktor-Authentifizierung",
  "myaccount_2fa_description": "Erhöhen Sie die Sicherheit Ihres Kontos durch die Aktivierung der Zwei-Faktor-Authentifizierung (2FA). Dies fügt Ihrem Konto eine zusätzliche Schutzebene hinzu.",
  "myaccount_2fa_card_description": "Aktivieren Sie die Zwei-Faktor-Authentifizierung, um Ihr Konto zu schützen.",
  "myaccount_2fa_select_method": "Authentifizierungsmethode auswählen",
  "myaccount_2fa_method": "Authentifizierungsmethode",
  "myaccount_2fa_method_placeholder": "Wählen Sie eine Authentifizierungsmethode",
  "myaccount_2fa_otp_description": "Verwenden Sie eine Authenticator-App (wie Google Authenticator oder Authy), um zeitbasierte Codes zu generieren.",
  "myaccount_2fa_email_description": "Erhalten Sie Bestätigungscodes per E-Mail.",
  "myaccount_2fa_sms_description": "Erhalten Sie Bestätigungscodes per SMS.",
  "myaccount_2fa_none_description": "Deaktivieren Sie die Zwei-Faktor-Authentifizierung für Ihr Konto.",
  "myaccount_2fa_scan_qr": "QR-Code scannen",
  "myaccount_2fa_scan_qr_description": "Scannen Sie diesen QR-Code mit Ihrer Authenticator-App, um die Zwei-Faktor-Authentifizierung einzurichten.",
  "myaccount_2fa_manual_entry": "Oder geben Sie diesen Code manuell ein:",
  "myaccount_2fa_copy_secret": "In die Zwischenablage kopieren",
  "myaccount_2fa_secret_copied": "Geheimer Schlüssel in die Zwischenablage kopiert",
  "myaccount_2fa_verify_code": "Code überprüfen",
  "myaccount_2fa_enter_code": "Bestätigungscode eingeben",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein, um die Einrichtung abzuschließen.",
  "myaccount_2fa_method_updated": "Zwei-Faktor-Authentifizierungsmethode erfolgreich aktualisiert",
  "myaccount_2fa_otp_enabled": "Zwei-Faktor-Authentifizierung erfolgreich aktiviert",
  "myaccount_2fa_current_status": "Aktueller Status",
  "myaccount_2fa_status": "Status der Zwei-Faktor-Authentifizierung",
  "myaccount_2fa_status_disabled": "Deaktiviert",
  "myaccount_2fa_error_no_keycloak_id": "2FA kann nicht konfiguriert werden: Benutzer-ID nicht gefunden",
  "myaccount_2fa_error_invalid_code": "Ungültiger Bestätigungscode. Bitte versuchen Sie es erneut.",
  "myaccount_2fa_error_generic": "Beim Konfigurieren der Zwei-Faktor-Authentifizierung ist ein Fehler aufgetreten",
  "myaccount_2fa_enabled": "Aktiviert",
  "myaccount_2fa_disabled_label": "Deaktiviert",
  "myaccount_2fa_disabled": "Zwei-Faktor-Authentifizierung erfolgreich deaktiviert",
  "myaccount_account_details": "Mein Konto",
  "myaccount_billing": "Proforma-Rechnungen",
  "myaccount_billing_contacts": "Kontakte verwalten",
  "myaccount_billing_contacts_description": "Alle E-Mails werden an die Adresse in Ihrem Hauptkonto gesendet. Geben Sie weitere Adressen ein, um Mitteilungen an zusätzliche Empfänger zu senden.",
  "myaccount_billing_description": "In diesem Abschnitt finden Sie Proforma-Rechnungen, die vor den steuerlichen Rechnungen ausgestellt wurden.<br>nSteuerrechnungen werden Ihnen per E-Mail zugesandt.",
  "myaccount_billing_details": "Konto & Rechnungsdetails",
  "myaccount_billing_details_address": "Adresse .",
  "myaccount_billing_details_address2": "Adresse 2",
  "myaccount_billing_details_billing_company_name": "Rechnungssteller",
  "myaccount_billing_details_billing_contact": "Senden Sie Proforma-Rechnungen an eine andere Adresse als die Kontoadresse",
  "myaccount_billing_details_billing_vat": "VAT / USt.-IdNr / C.F.",
  "myaccount_billing_details_billing_website": "Website",
  "myaccount_billing_details_city": "Stadt",
  "myaccount_billing_details_country": "Land",
  "myaccount_billing_details_description": "Kontodaten und Rechnungsadresse ändern.",
  "myaccount_billing_details_details": "Angaben zur Rechnungsstellung",
  "myaccount_billing_details_email": "E-Mail Adresse",
  "myaccount_billing_details_fistname": "Vorname",
  "myaccount_billing_details_lastname": "Nachname",
  "myaccount_billing_details_marketing": "Ich möchte gezielte Angebote und Empfehlungen von turboSMTP erhalten",
  "myaccount_billing_details_phone_number": "Telefonnummer",
  "myaccount_billing_details_policy": "Ich habe die Datenschutzbestimmungen und die Allgemeinen Geschäftsbedingungen gelesen und und akzeptiere sie.",
  "myaccount_billing_details_state": "Bundesland/Region",
  "myaccount_billing_details_zip": "Postleitzahl",
  "myaccount_billing_slides_description": "Hier finden Sie die 'Proforma-Rechnungen' zu Ihrem Konto.",
  "myaccount_billing_cancellation_select_reason": "Wählen Sie einen Grund",
  "myaccount_billing_slides_nodata": "Es wurden keine Proforma-Rechnungen gefunden",
  "myaccount_billingcontacts_added": "Rechnungskontakt erfolgreich hinzugefügt",
  "myaccount_billingcontacts_deleted": "Rechnungskontakt erfolgreich gelöscht",
  "myaccount_billingcontacts_edited": "Rechnungskontakt erfolgreich bearbeitet",
  "myaccount_billingdetails_updated": "Rechnungsdetails wurden aktualisiert",
  "myaccount_change_password": "Passwort ändern",
  "myaccount_confirm_delete_selectedcontact_label": "Vorgang bestätigen",
  "myaccount_confirm_delete_selectedcontact_text": "Möchten Sie diesen Kontakt wirklich löschen?",
  "myaccount_confirm_password": "Passwort bestätigen",
  "myaccount_current_password": "Aktuelles Passwort überprüfen",
  "myaccount_language": "Sprache anzeigen",
  "myaccount_language_change": "Sprache ändern",
  "myaccount_language_description": "TurboSMTP ist jetzt in Englisch und Italienisch verfügbar. (Französisch, Deutsch, Hebräisch, Portugiesisch, Russisch, Arabisch und Spanisch folgen in Kürze).",
  "myaccount_language_select": "Sprache auswählen",
  "myaccount_messages": "System-Meldungen",
  "myaccount_messages_nomessages_description": "In diesem Bereich finden Sie die Nachrichten, die unser System an Ihr Konto gesendet hat.",
  "myaccount_new_password": "Neues Passwort",
  "myaccount_password_changed": "Das Passwort wurde erfolgreich geändert",
  "myaccount_password_choose": "Wählen Sie Ihr neues Passwort",
  "myaccount_password_notmatch": "Diese Passwörter stimmen nicht überein. Versuchen Sie es erneut.",
  "myaccount_password_suggestions": "Passwörter sollten mindestens 10 Zeichen enthalten, darunter sowohl Groß- als auch Kleinbuchstaben und mindestens eine Zahl.",
  "myaccount_product_delete_label": "Vorgang bestätigen",
  "myaccount_product_delete_text": "Sind Sie sicher, dass Sie dieses Produkt stornieren möchten?",
  "myaccount_products": "Meine Produkte",
  "myaccount_products_billingcycle": "Abrechnungszeitraum",
  "myaccount_products_cycle_annually": "Jährlich",
  "myaccount_products_cycle_biennally": "Zweijährlich",
  "myaccount_products_cycle_free_account": "Gratis Konto",
  "myaccount_products_cycle_month": "Monatlich",
  "myaccount_products_cycle_monthly": "Monatlich",
  "myaccount_products_cycle_one_time": "Einmalig",
  "myaccount_products_cycle_onetime": "Einmalig",
  "myaccount_products_cycle_quarterly": "Vierteljährlich",
  "myaccount_products_cycle_semi-annually": "Halbjährlich",
  "myaccount_products_cycle_triennially": "Dreijährlich",
  "myaccount_products_cycle_year": "Jährlich",
  "myaccount_products_cycle_yearly": "Jährlich",
  "myaccount_products_fistpayment": "Erster Zahlungsbetrag",
  "myaccount_products_nextduedate": "Nächstes Fälligkeitsdatum",
  "myaccount_products_noproduct_description": "In diesem Bereich finden Sie die Produkte und Dienstleistungen, die mit dem Konto verknüpft sind.",
  "myaccount_products_payment": "Zahlungsmethode",
  "myaccount_products_price": "Preis",
  "myaccount_products_productservice": "Produkt/Dienstleistung",
  "myaccount_products_recurringamount": "Wiederkehrender Betrag",
  "myaccount_products_registration": "Registrierungsdatum",
  "myaccount_products_slide_productservice_description": "Verwalten Sie Ihr Produkt direkt von diesem Bereich aus.",
  "myaccount_products_status": "Status",
  "plans_addon_options_title": "Zusatzpläne",
  "plans_available_recurring_options_title": "Verfügbare Pläne",
  "plans_billing_cycle": "Abrechnungszyklus",
  "plans_current_plans_title": "Ihre aktuellen Pläne",
  "plans_cycle_month": "Monatlich",
  "plans_cycle_monthly": "Monatlich",
  "plans_cycle_onetime": "Einmalig",
  "plans_cycle_year": "Jährlich",
  "plans_cycle_yearly": "Jährlich",
  "plans_downgrade_options_title": "Downgrade-Optionen",
  "plans_feature_dedicated_ip": "Dedizierte IP",
  "plans_feature_email_credits": "E-Mail-Guthaben",
  "plans_feature_smtp_limit": "SMTP-Limit",
  "plans_features": "Funktionen",
  "plans_invoice_created": "Die Rechnung wurde erfolgreich erstellt.",
  "plans_invoice_error": "Rechnung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
  "plans_load_error": "Planoptionen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
  "plans_onetime_options_title": "Einmalige Pläne",
  "plans_plan_name": "Planname",
  "plans_plan_type": "Plantyp",
  "plans_select_plan": "Plan auswählen",
  "plans_type_addon": "Zusatz",
  "plans_type_onetime": "Einmalig",
  "plans_type_recurring": "Wiederkehrend",
  "plans_upgrade_options_title": "Upgrade-Optionen",
  "myaccount_sentdate": "Versanddatum",
  "new_dashboard_error": "Leider ist ein Fehler aufgetreten:",
  "new_dashboard_if_you_think": "Wenn Sie glauben, dass Sie diese Meldung irrtümlich sehen, wenden Sie sich bitte an <a href=\"https://serversmtp.com/de/kontakte/\" target=\"_blank\">contact us</a>.",
  "new_dashboard_not_allowed": "Kontaktieren Sie unser <a href='https://serversmtp.com/de/kontakte/' target='_blank'>Support-Team</a> um die Beta-Version des Dashboards zu nutzen.",
  "new_dashboard_token_valid": "Token ist gültig",
  "new_dashboard_token_wrong": "Token ist nicht korrekt",
  "new_dashboard_validating": "Validierung des Tokens...",
  "no": "Kein",
  "no_parameters_was_provided_for_update": "Es wurde kein Aktualisierungsparameter angegeben",
  "no_suppression_data_were_provided": "Es wurden keine Unterdrückungsdaten angegeben",
  "one_time": "Einmalig",
  "optional": "Optional",
  "or": "oder",
  "password_is_invalid": "Dieses Passwort entspricht keinem Konto",
  "password_is_missing": "Passwort fehlt",
  "password_length_should_not_be_less_than_10_characters": "Passwort muss mindestens 10 Zeichen enthalten",
  "password_should_contain_at_least_one_uppercase_character": "Das Passwort muss mindestens 1 Großbuchstaben enthalten",
  "password_should_contain_at_least_one_lowercase_character": "Das Passwort muss mindestens 1 Kleinbuchstaben enthalten",
  "password_should_contain_at_least_one_digit": "Das Passwort muss mindestens 1 Ziffer enthalten",
  "password_should_equals_to_confirm_password": "Passwort und Passwortbestätigung müssen übereinstimmen",
  "plan": "plan",
  "plan_daily": "Tagesplan",
  "plan_monthly": "Monatsplan",
  "plan_yearly": "Jahresplan",
  "primeng": {
    "accept": "Ja",
    "addRule": "Regel hinzufügen",
    "after": "Nach",
    "apply": "Anwenden",
    "before": "Vor",
    "cancel": "Abbrechen",
    "choose": "Auswählen",
    "clear": "Löschen",
    "contains": "Inhalt:",
    "dateAfter": "Datum ist nach",
    "dateBefore": "Datum ist vor",
    "dateFormat": "yy/mm/dd",
    "dateIs": "Datum ist",
    "dateIsNot": "Datum ist nicht",
    "dayNames": [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    "dayNamesMin": [
      "So",
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa"
    ],
    "dayNamesShort": [
      "Son",
      "Mon",
      "Die",
      "Mit",
      "Don",
      "Fre",
      "Sam"
    ],
    "emptyFilterMessage": "Keine Einträge gefunden",
    "emptyMessage": "Keine Einträge gefunden",
    "endsWith": "Endet mit",
    "equals": "Entspricht",
    "firstDayOfWeek": 1,
    "gt": "Größer als",
    "gte": "Größer oder gleich",
    "is": "Ist",
    "isNot": "Ist nicht",
    "lt": "Kleiner als",
    "lte": "Kleiner oder gleich",
    "max_limit_reached": "Sie haben die maximale Anzahl an aktivierbaren Subaccounts für Ihren aktuellen Plan erreicht.",
    "matchAll": "Alle übereinstimmen",
    "matchAny": "Beliebige Übereinstimmung",
    "medium": "Mittel",
    "monthNames": [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    "monthNamesShort": [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    "noFilter": "Kein Filter",
    "notContains": "Enthält nicht",
    "notEquals": "Entspricht nicht",
    "passwordPrompt": "Enter a password",
    "reject": "Keine",
    "removeRule": "Regel entfernen",
    "startsWith": "Beginnt mit",
    "strong": "stark",
    "today": "Heute",
    "upload": "Hochladen",
    "weak": "Schwach",
    "weekHeader": "Woche"
  },
  "saturday": "Samstag",
  "server_error_please_try_again": "Serverfehler. Bitte versuchen Sie es später erneut.",
  "server_error_while_performing_update": "Während der Aktualisierung ist ein Serverfehler aufgetreten",
  "server_problem_gateway_timeout": "Timeout des Server-Gateways, bitte versuchen Sie es erneut.",
  "server_problem_please_retry": "Serverproblem, bitte versuchen Sie es erneut.",
  "server_problem_unknown_error": "Unbekannter Serverfehler, bitte versuchen Sie es erneut.",
  "settings_activities_description": "Erhalten Sie Berichte über Ihre Kontoaktivitäten in Ihrer Mailbox. Die Berichte können täglich, wöchentlich und/oder monatlich erstellt werden und umfassen alle Aktivitäten Ihres Kontos.",
  "settings_activities_slide_dailyreport": "Täglicher Bericht",
  "settings_activities_slide_day": "Tag",
  "settings_activities_slide_dayoftheweek": "Wochentag",
  "settings_activities_slide_description": "Sie können tägliche, wöchentliche und monatliche Berichte über alle Aktivitäten Ihres Kontos erhalten. Der Bericht wird an Ihre registrierte E-Mail-Adresse gesendet.",
  "settings_activities_slide_monthlyreport": "Monatlicher Bericht",
  "settings_activities_slide_time": "Zeit",
  "settings_activities_slide_title": "Aktivitätsberichte",
  "settings_activities_slide_weeklyreport": "Wöchentlicher Bericht",
  "settings_activities_title": "Aktivitätsberichte",
  "settings_alert_usage_limit": "Nutzungslimit",
  "settings_alerts_description": "Erhalt einer E-Mail-Benachrichtigung, wenn Sie einen bestimmten Prozentsatz Ihres E-Mail-Guthabens verbraucht haben.",
  "settings_alerts_slide_add": "Warnhinweis hinzufügen",
  "settings_alerts_slide_description": "Um zu vermeiden, dass Ihnen mitten in einem Mailing die Relais ausgehen, können Sie sich per E-Mail benachrichtigen lassen, wenn Sie einen bestimmten Prozentsatz Ihres Guthabens erreicht haben. Warnhinweis bei 80 % Ihres verfügbaren Guthabens zu aktivieren.",
  "settings_alerts_slide_empty_description": "Richten Sie einen Warnhinweis ein, der Sie bei Erreichen eines bestimmten Prozentsatzes Ihres Guthabens per E-Mail benachrichtigt.",
  "settings_alerts_slide_empty_title": "Warnhinweis hinzufügen",
  "settings_alerts_slide_frequency": "Häufigkeit",
  "settings_alerts_slide_percentage": "Prozentsatz",
  "settings_alerts_slide_placeholder": "z. B. name@adresse.com",
  "settings_alerts_slide_sendto": "Senden an",
  "settings_alerts_slide_title": "Warnhinweis",
  "settings_alerts_slide_type": "Art des Warnhinweises",
  "settings_alerts_title": "Warnhinweis",
  "settings_api_description": "Versenden Sie Ihre E-Mails direkt von Ihrer Website oder App mit turboSMTP API.",
  "settings_api_title": "API-Dokumentation",
  "settings_bccs_description": "Alle E-Mail-Adressen in der BCC-Liste erhalten eine Kopie jeder E-Mail, ohne dass der Empfänger die Details der anderen Empfänger sieht.",
  "settings_bccs_enable": "Aktivieren Sie die Autorisierung eines E-Mail-Kontos, um eine Kopie aller gesendeten E-Mails zu erhalten.",
  "settings_bccs_slide_add": "BCCs hinzufügen",
  "settings_bccs_slide_description": "Bitte konfigurieren und autorisieren Sie ein oder mehrere E-Mail-Konten, die eine Kopie der E-Mails erhalten sollen.",
  "settings_bccs_slide_email": "E-Mail",
  "settings_bccs_slide_empty": "Bitte konfigurieren und autorisieren Sie ein E-Mail-Konto, das eine Kopie der E-Mails erhalten soll.",
  "settings_bccs_slide_empty_title": "BCC-Adresse hinzufügen",
  "settings_bccs_slide_name": "Name",
  "settings_bccs_slide_not_verified": "Nicht geprüft",
  "settings_bccs_slide_status": "Status",
  "settings_bccs_slide_title": "BCCs (Blind Carbon Copy)",
  "settings_bccs_slide_verified": "Geprüft",
  "settings_bccs_title": "BCCs (Blind Carbon Copy)",
  "settings_bounces_description": "Wenn Sie die Bounce-Benachrichtigungen aktivieren, werden Benachrichtigungen über Ihre unzustellbaren E-Mails an uns gesendet. Um alle Bounce-Benachrichtigungen selbst zu erhalten, deaktivieren Sie diese Option.",
  "settings_bounces_title": "Bounce-Verwaltung",
  "settings_click_tracking": "Klick-Tracking",
  "settings_click_tracking_description": "Klick-Tracking zeichnet alle Klicks auf jeden Link in Ihren E-Mails auf.",
  "settings_dns_bar_description": "Sowohl SPF- als auch DKIM-Einträge sollten zu allen Domänen Ihrer Absender-E-Mail-Adressen hinzugefügt werden.",
  "settings_dns_bar_dkim_description": "Ein DKIM-Eintrag kann als TXT-Eintrag hinzugefügt werden, indem Sie Folgendes einfügen:",
  "settings_dns_bar_dkim_title": "DKIM-Einträge",
  "settings_dns_bar_domainaut": "Domänen-Authentifizierung",
  "settings_dns_bar_domainaut_description": "Autorisieren Sie TurboSMTP, E-Mails in Ihrem Namen zu versenden.",
  "settings_dns_bar_domainaut_is": "Der 'Domain Verifizierung'-Modus ist:",
  "settings_dns_bar_spf_description": "Fügen Sie den folgenden TXT-Eintrag zur Domain der Umschlagadresse (example.com) hinzu, in einem der beiden folgenden Fälle:",
  "settings_dns_bar_spf_description_a": "<strong>Wenn in der DNS-Konfiguration Ihrer Domain bereits ein SPF-Eintrag vorhanden ist</strong>, müssen Sie ihn ändern. Fügen Sie einfach",
  "settings_dns_bar_spf_description_b": "direkt nach dem Segment ein",
  "settings_dns_bar_spf_description_c": "Bitte beachten Sie, dass vor und nach dem Eintrag ein Leerzeichen stehen muss, um die korrekte Syntax zu gewährleisten.",
  "settings_dns_bar_spf_description_d": "<strong>Wenn kein SPF-Eintrag</strong> vorhanden ist, erstellen Sie einen indem Sie die erforderlichen Informationen in einen neuen TXT-Eintrag in der DNS-Konfiguration Ihrer Domain eingeben (Eine SPF-Domain muss nicht angeben werden, außer es ist erforderlich):",
  "settings_dns_bar_spf_title": "SPF-Eintrag",
  "settings_dns_bar_title": "DNS-Einstellungen",
  "settings_dns_description": "Fügen Sie Ihrer Domain unsere DNS-Einträge hinzu, um Ihre E-Mails mit DKIM zu zertifizieren und eine optimale Zustellbarkeit zu gewährleisten.",
  "settings_dns_title": "DNS-Einträge",
  "settings_email_body_tip": "Bitte bei der Eingabe <% body %> angeben.",
  "settings_email_elements": "E-Mail-Elemente",
  "settings_email_footers_added": "Fußzeile erfolgreich hinzugefügt",
  "settings_email_footers_confirm_delete_label": "Vorgang bestätigen",
  "settings_email_footers_confirm_delete_text": "Möchten Sie diese Fußzeile wirklich löschen?",
  "settings_email_footers_default": "Fußzeileneinstellungen erfolgreich aktualisiert",
  "settings_email_footers_removed": "Fußzeile erfolgreich entfernt",
  "settings_email_footers_updated": "Fußzeile erfolgreich aktualisiert",
  "settings_email_name_tip": "Bitte geben Sie einen Namen an",
  "settings_email_templates_added": "Vorlage erfolgreich hinzugefügt",
  "settings_email_templates_confirm_delete_label": "Vorgang bestätigen",
  "settings_email_templates_confirm_delete_text": "Möchten Sie diese Vorlage wirklich löschen?",
  "settings_email_templates_default": "Vorlageneinstellungen erfolgreich aktualisiert",
  "settings_email_templates_removed": "Vorlage erfolgreich entfernt",
  "settings_email_templates_updated": "Vorlage erfolgreich aktualisiert",
  "settings_email_unsub_added": "Abmeldelink erfolgreich hinzugefügt",
  "settings_email_unsub_confirm_delete_label": "Vorgang bestätigen",
  "settings_email_unsub_confirm_delete_text": "Möchten Sie diesen Abmeldelink wirklich löschen?",
  "settings_email_unsub_removed": "Abmeldelink erfolgreich entfernt",
  "settings_email_unsub_updated": "Abmeldelink erfolgreich aktualisiert",
  "settings_footers_description": "E-Mails eine Fußzeile hinzufügen.",
  "settings_footers_slide_add": "Fußzeile hinzufügen",
  "settings_footers_slide_convert": "HTML zu Text",
  "settings_footers_slide_default": "Standard",
  "settings_footers_slide_description": "Klicken Sie auf \"Fußzeile hinzufügen\" oder bearbeiten Sie eine vorhandene Fußzeile, geben Sie dann den Namen der Fußzeile ein und füllen Sie die Felder mit HTML oder einfachem Text aus.",
  "settings_footers_slide_empty_description": "Klicken Sie auf \"Fußzeile hinzufügen\" oder bearbeiten Sie eine vorhandene Fußzeile, geben Sie dann den Namen der Fußzeile ein und füllen Sie die Felder mit HTML oder einfachem Text aus.",
  "settings_footers_slide_empty_title": "Keine Fußzeilen",
  "settings_footers_slide_htmltext": "HTML-Text",
  "settings_footers_slide_name": "Name",
  "settings_footers_slide_plaintext": "Einfacher Text",
  "settings_footers_slide_title": "Fußzeilen",
  "settings_footers_title": "Fußzeilen",
  "settings_ga_bar_description": "Bitte füllen Sie die folgenden Felder aus, einschließlich des Namens und der Quelle Ihrer Kampagnendaten, um Ihre Google Analytics-Integration zu aktivieren.",
  "settings_ga_bar_title": "Google-Analytics",
  "settings_ga_content": "Kampagneninhalt",
  "settings_ga_content_mandatory": "Kampagneninhalt ist obligatorisch",
  "settings_ga_integrate": "Integrieren Sie Google Analytics, um Ihre Konversionsraten und andere Daten zu verfolgen",
  "settings_ga_medium": "Kampagnenmedium",
  "settings_ga_medium_mandatory": "Kampagnenmedium ist obligatorisch",
  "settings_ga_name": "Kampagnenname",
  "settings_ga_name_mandatory": "Kampagnenname ist obligatorisch",
  "settings_ga_parameters": "Parameter",
  "settings_ga_parameters_description": "Bitte füllen Sie die folgenden Felder aus, einschließlich des Namens und der Quelle Ihrer Kampagnendaten, um Ihre Google Analytics-Integration zu aktivieren.",
  "settings_ga_source": "Kampagnenquelle",
  "settings_ga_source_mandatory": "Kampagnenquelle ist obligatorisch",
  "settings_ga_term": "Kampagnenbegriff",
  "settings_ga_term_mandatory": "Kampagnenbegriff ist obligatorisch",
  "settings_google_analytics_description": "Google Analytics verfolgt Ihre Konversionsraten und andere Daten.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "Integrationen",
  "settings_integrations_authentication_disabled": "Der 'Domain Verifizierung'-Modus ist: Deaktiviert",
  "settings_integrations_authentication_enabled": "Der 'Domain Verifizierung'-Modus ist: Aktiviert",
  "settings_integrations_dkim_updated": "DKIM-Einstellungen erfolgreich aktualisiert",
  "settings_notification_alert_confirm_delete_label": "Vorgang bestätigen",
  "settings_notification_alert_confirm_delete_text": "Möchten Sie diesen Warnhinweis wirklich löschen?",
  "settings_notification_bcc_confirm_delete_label": "Vorgang bestätigen",
  "settings_notification_bcc_confirm_delete_success": "Die BCC {email} wurde erfolgreich gelöscht.",
  "settings_notification_bcc_confirm_delete_text": "Möchten Sie diese BCC {email} wirklich löschen?",
  "settings_notification_smtp_auth": "SMTP-Authentifizierung",
  "settings_notifications": "Benachrichtigungen",
  "settings_notifications_alert_added": "Warnhinweis wurde erfolgreich erstellt",
  "settings_notifications_alert_deleted": "Warnhinweis wurde erfolgreich gelöscht.",
  "settings_notifications_alert_updated": "Warnhinweis wurde erfolgreich aktualisiert",
  "settings_notifications_bcc_emailbox": "Wir haben soeben eine Bestätigungsnachricht an <{email}> gesendet.",
  "settings_notifications_bcc_update_success": "Das BCC {email} wurde erfolgreich aktualisiert.",
  "settings_notifications_smtp_auth_enabled": "Aktiviert",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com/",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(das Passwort, das Sie verwenden, um auf dieses Dashboard zuzugreifen)",
  "settings_notifications_smtp_password": "SMTP-Passwort",
  "settings_notifications_smtp_ports": "SMTP-Ports",
  "settings_notifications_smtp_server": "SMTP-Server",
  "settings_notifications_smtp_username": "SMTP-Benutzername",
  "settings_open_tracking": "Open Tracking",
  "settings_open_tracking_description": "Wenn Sie Open Tracking aktivieren, wird eine Aufstellung Ihrer geöffneten Nachrichten generiert, so dass Sie die Ergebnisse Ihrer Kampagne besser verfolgen können.",
  "settings_setting_changed": "Einstellung geändert {Service}",
  "settings_setting_disabled": "Einstellung deaktiviert {service}",
  "settings_setting_enabled": "Einstellung aktiviert {Service}",
  "settings_setting_notdisabled": "Einstellung {Service} kann nicht aktiviert werden.",
  "settings_setting_notenabled": "Einstellung {service} kann nicht aktiviert werden.",
  "settings_setting_webhook_notenabled": "Web-Hooks für Ereignisbenachrichtigungen sind nur für PRO-Tarife verfügbar.",
  "settings_smtp_description": "Um eine Verbindung über SMTP herzustellen, konfigurieren Sie SMTP in Ihrem Mail-Client oder in einer anderen Mailing-App, indem Sie die folgenden Parameter hinzufügen. Klicken Sie auf die Schaltfläche \"Mehr\", um die Parameter zu sehen.",
  "settings_smtp_slide_description": "Konfigurieren Sie SMTP in Ihrem Mail-Client oder in einer anderen Mailing-Anwendung, indem Sie die folgenden Parameter hinzufügen.",
  "settings_smtp_slide_description_api": "Der SMTP-Authentifizierungsbenutzername und das Passwort sind ein Paar von API-Schlüsseln: Verwenden Sie den Consumer Key als SMTP-Benutzernamen und den Consumer Secret als SMTP-Passwort. Behandeln Sie sie als Zugangsdaten, die geheim gehalten und bei Bedarf ausgetauscht werden müssen.",
  "settings_smtp_slide_parameter": "Parameter",
  "settings_smtp_slide_title": "Verbinden über SMTP",
  "settings_smtp_slide_value": "Wert",
  "settings_smtp_title": "Verbinden über SMTP",
  "settings_template_description": "Vorlagen sind das perfekte Tool, um Ihrer E-Mail auf einfache Weise ein effektives Layout zu geben.",
  "settings_template_slide_add": "Vorlage hinzufügen",
  "settings_template_slide_default": "Standard",
  "settings_template_slide_description": "Klicken Sie auf \"Vorlage hinzufügen\" und füllen Sie die Felder mit den erforderlichen Informationen aus, einschließlich des Namens der Vorlage und des HTML- oder einfachen Textes.",
  "settings_template_slide_empty_description": "Klicken Sie auf \"Vorlage hinzufügen\" und füllen Sie die Felder mit den erforderlichen Informationen aus, einschließlich des Namens der Vorlage und des HTML- oder einfachen Textes.",
  "settings_template_slide_empty_title": "Vorlage hinzufügen",
  "settings_template_slide_html": "HTML-Version",
  "settings_template_slide_info": "<% body %> ist im HTML-Text und im einfachen Text obligatorisch. Der Platzhalter wird durch echten Inhalt ersetzt.",
  "settings_template_slide_name": "Name der Vorlage",
  "settings_template_slide_plaintext": "Einfache Textversion",
  "settings_template_slide_title": "Vorlagen",
  "settings_template_title": "Vorlagen",
  "settings_title": "Einstellungen",
  "settings_tracking": "Tracking",
  "settings_unsubscribe_description": "Fügen Sie am Ende von Text- und HTML-E-Mails einen Abmeldelink ein. An abgemeldete Benutzer werden keine E-Mails zugestellt.",
  "settings_unsubscribe_select": "Wählen Sie eine Sprache",
  "settings_unsubscribe_slide_add": "Abmeldelink hinzufügen",
  "settings_unsubscribe_slide_description": "Fügen Sie am Ende von Text- und HTML-E-Mails einen Abmeldelink ein. An abgemeldete Benutzer werden keine E-Mails zugestellt. Abmeldungen werden automatisch und in Echtzeit bearbeitet, um Ihre E-Mail-Reputation zu verbessern. Geben Sie den gewünschten Text ein (z. B. \" Zum Abmelden hier klicken\") und fügen Sie ihn in den Platzhalter in Ihrer Nachricht ein.",
  "settings_unsubscribe_slide_empty": "Fügen Sie einen Abmeldelink ein",
  "settings_unsubscribe_slide_empty_description": "Fügen Sie am Ende von Text- und HTML-E-Mails einen Abmeldelink ein. An abgemeldete Benutzer werden keine E-Mails zugestellt. Abmeldungen werden automatisch und in Echtzeit bearbeitet, um Ihre E-Mail-Reputation zu verbessern.",
  "settings_unsubscribe_slide_language": "Wählen Sie eine Sprache",
  "settings_unsubscribe_slide_placeholder": "Platzhalter",
  "settings_unsubscribe_slide_text": "Abmeldetext",
  "settings_unsubscribe_slide_title": "Abmeldelink",
  "settings_unsubscribe_text": "Text",
  "settings_unsubscribe_title": "Abmeldelink",
  "settings_unsubscribe_value": "Beispiel: Zum Abmelden, hier klicken",
  "settings_webhooks_description": "Webhooks ermöglichen es Ihrer Webanwendung, Benachrichtigungen über E-Mail-Zustellungen und Interaktionsereignisse zu erhalten.",
  "settings_webhooks_slide_alert": "Die Änderung kann bis auf eine Stunde dauern bis sie gültig sind.",
  "settings_webhooks_slide_bounced": "Unzustellbar",
  "settings_webhooks_slide_click": "Klicks",
  "settings_webhooks_slide_deferred": "Verzögert",
  "settings_webhooks_slide_delivered": "Zugestellt",
  "settings_webhooks_slide_deliveryevents": "Zustellungsereignisse",
  "settings_webhooks_slide_description": "Sie können Ereignisbenachrichtigungs-Webhooks verwenden, um über Ereignisse in Ihrem E-Mail-Projekt benachrichtigt zu werden, ohne APIs zu verwenden.",
  "settings_webhooks_slide_dropped": "Abgelehnt",
  "settings_webhooks_slide_engagementevents": "Engagement-Events",
  "settings_webhooks_slide_inserturl": "Geben Sie hier die Url ein, über die Sie benachrichtigt werden möchten",
  "settings_webhooks_slide_notification": "Webhook-Benachrichtigungs-Url",
  "settings_webhooks_slide_notification_description": "Aktivieren Sie Webhook-Benachrichtigungen",
  "settings_webhooks_slide_open": "Öffnen",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "Verarbeitet",
  "settings_webhooks_slide_spamreport": "Spam-Bericht",
  "settings_webhooks_slide_title": "Webhooks",
  "settings_webhooks_slide_unsubscribe": "Abmelden",
  "settings_webhooks_support": "Bitte kontaktieren Sie den Support und fragen Sie nach 'Delivery Events Activation'.",
  "settings_webhooks_title": "Webhooks",
  "settings_webhooks_upgrade": "Upgrade auf PRO-Plan",
  "subaccount_policy_agree": "Ich habe die <a href=\"https://serversmtp.com/de/de_terms-and-conditions/\" target=\"_blank\">Allgemeinen Geschäftsbedingungen</a> und <a href=\"https://serversmtp.com/de/datenschutzerklarung-eu-verordnung-2016-79-dsgvo/\" target=\"_blank\">Datenschutzbestimmungen</a> gelesen und akzeptiere sie.",
  "subaccount_policy_agree_notchecked": "Sie müssen die Allgemeinen Geschäftsbedingungen und die Datenschutzbestimmungen akzeptieren.",
  "subaccount_slide_inuse": "In Verwendung",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "IPs",
  "subaccount_slide_ips_description": "Bitte wählen Sie eine IP aus, die Sie diesem Unterkonto zuweisen möchten.",
  "subaccounts_action_activated": "{email} wurde erfolgreich aktiviert",
  "subaccounts_action_active": "Aktiv",
  "subaccounts_action_deactivated": "{email} wurde erfolgreich gesperrt",
  "subaccounts_action_delete": "Löschen",
  "subaccounts_action_deleted": "Unterkonto erfolgreich gelöscht",
  "subaccounts_action_details": "Details",
  "subaccounts_action_edit": "Bearbeiten",
  "subaccounts_action_limit": "Grenzen setzen",
  "subaccounts_action_login": "Anmeldung",
  "subaccounts_action_notdeleted": "Fehler beim Löschen des Unterkontos",
  "subaccounts_action_suspend": "Unterbrechen",
  "subaccounts_active": "Aktiv",
  "subaccounts_added_succesfully": "Das Unterkonto wurde erfolgreich hinzugefügt",
  "subaccounts_agencysettings": "Agentur-Einstellungen",
  "subaccounts_assigned_ip": "Zugewiesene IP",
  "subaccounts_changed_succesfully": "Das Unterkonto wurde erfolgreich geändert",
  "subaccounts_confirm_activation_label": "Aktivierung bestätigen",
  "subaccounts_confirm_activation_text": "Möchten Sie {email} aktivieren?",
  "subaccounts_confirm_deactivation_label": "Deaktivierung bestätigen",
  "subaccounts_confirm_deactivation_text": "Möchten Sie das Unterkonto sperren: {E-Mail}?",
  "subaccounts_confirm_delete_label": "Löschung bestätigen",
  "subaccounts_confirm_delete_text": "Möchten Sie das Unterkonto {email} löschen?",
  "subaccounts_confirm_login_label": "Anmeldung bestätigen",
  "subaccounts_confirm_login_text": "Sind Sie sicher, dass Sie sich vom aktuellen Konto abmelden und bei {email} anmelden möchten?",
  "subaccounts_confirmation": "Bestätigung",
  "subaccounts_create_warning": "Das Erstellen neuer Unterkonten ist nur bei Professional-Abonnements möglich.",
  "subaccounts_email": "Konto E-Mail",
  "subaccounts_empty": "Erweitern Sie Ihr Angebot und bieten Sie Ihren Kunden einen professionellen Service, der vollständig an Ihre Markenidentität angepasst werden kann, oder teilen Sie Ihre E-Mails unter Ihren Mitarbeitern und Kollegen auf.<br> Eine einfache Verwaltungsschnittstelle ermöglicht es Ihnen, den Datenverkehr und die Statistiken zu verfolgen.",
  "subaccounts_expiration_date": "Ablaufdatum",
  "subaccounts_inactive": "Inaktiv",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "Letzte Aktivität",
  "subaccounts_limits_nolimits": "Keine Limits",
  "subaccounts_limits_sending": "Sendelimit:",
  "subaccounts_limits_slide_description": "Legen Sie ein Limit für Ihr Unterkonto fest.",
  "subaccounts_limits_slide_limits": "Limits",
  "subaccounts_limits_slide_noplan_expiration": "Kein Ablauf",
  "subaccounts_limits_slide_plan_expiration": "Ablauf des Plans",
  "subaccounts_limits_slide_set_plan_expiration": "Ablauf des Plans festlegen",
  "subaccounts_limits_slide_this_number": "Diese Zahl bezieht sich auf einen Zeitraum",
  "subaccounts_limits_slide_title": "Limits für Unterkonten",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class=\"pi pi-info-circle\"></i>",
  "subaccounts_no_expiration_tooltip": "Entsprechend dem Ablauf des Hauptkontos.",
  "subaccounts_settings_update": "Die Einstellungen des Unterkontos werden jetzt aktualisiert.",
  "subaccounts_slide_account_confirm": "Bestätigen Sie die Kontodetails",
  "subaccounts_slide_account_description": "Klicken Sie auf die Schaltfläche \"Bearbeiten\", um die Benutzerinformationen Ihres Unterkontos zu ändern.",
  "subaccounts_slide_account_info": "Kontoinformationen",
  "subaccounts_slide_address": "Adresse",
  "subaccounts_slide_address2": "Adresse 2",
  "subaccounts_slide_change_password": "Passwort einrichten",
  "subaccounts_slide_city": "Stadt",
  "subaccounts_slide_company": "Firmenname",
  "subaccounts_slide_confirm_password": "Passwort bestätigen",
  "subaccounts_slide_confirmpassword_different": "Bitte achten Sie darauf, dass Ihre Passwörter übereinstimmen.",
  "subaccounts_slide_country": "Land",
  "subaccounts_slide_email": "E-Mail Adresse",
  "subaccounts_slide_email_not_unique": "Diese E-Mail-Adresse wird bereits verwendet.",
  "subaccounts_slide_email_required": "Eine E-Mail-Adresse ist erforderlich.",
  "subaccounts_slide_first_name": "Vorname",
  "subaccounts_slide_firstname_required": "Vorname ist erforderlich.",
  "subaccounts_slide_last_name": "Nachname",
  "subaccounts_slide_lastname_required": "Nachname ist erforderlich.",
  "subaccounts_slide_password": "Passwort",
  "subaccounts_slide_password_details": "Lassen Sie das Passwortfeld leer, um Ihr aktuelles Passwort weiter zu verwenden.",
  "subaccounts_slide_password_minlength": "Die Länge des Passworts sollte mindestens {req} betragen. Derzeit ist es: {act}.",
  "subaccounts_slide_password_required": "Passwort ist erforderlich.",
  "subaccounts_slide_password_pattern": "Das Passwort muss mindestens 10 Zeichen enthalten, davon mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer",
  "subaccounts_slide_phone": "Telefon",
  "subaccounts_slide_profile_information": "Profil-Informationen",
  "subaccounts_slide_region": "Staat/Region/Provinz",
  "subaccounts_slide_website": "Website",
  "subaccounts_slide_zip": "Postleitzahl",
  "subaccounts_status": "Status",
  "subaccounts_subaccounts": "Unterkonten-Liste",
  "subaccounts_title": "Unterkonten",
  "subaccounts_unlimited": "Unbegrenzt <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "Entsprechend dem Limit des Hauptkontos.",
  "subaccounts_usage": "Verwendung",
  "sunday": "Sonntag",
  "suppression_deleted": "Unterdrückungen werden in Kürze gelöscht.",
  "suppression_filters_reason": "Begründung",
  "suppression_filters_recipient": "Empfänger",
  "suppression_filters_sender": "Absender",
  "suppression_filters_sources": "Quellen",
  "suppression_filters_subject": "Betreff der E-Mail",
  "suppression_operators_exclude": "Ausschließen",
  "suppression_operators_include": "Einschließen",
  "suppression_table_addcolumn_sender": "Absender",
  "suppression_types_bounce": "Unzustellbar",
  "suppression_types_manual": "Manuell",
  "suppression_types_spam": "Spam",
  "suppression_types_unsubscribe": "Abgemeldet",
  "suppression_types_validation_failed": "Validierung fehlgeschlagen",
  "suppressions_add_form_errors": "Formularfehler",
  "suppressions_add_form_nofile_selected": "Keine Datei ausgewählt",
  "suppressions_add_suppression": "Importunterdrückungen",
  "suppressions_choose_columns": "Spalten auswählen",
  "suppressions_confirm_delete_all_label": "Vorgang bestätigen",
  "suppressions_confirm_delete_all_text": "Möchten Sie wirklich alle Unterdrückungen zwischen <strong>{from}</strong> und <strong>{to}</strong> löschen?",
  "suppressions_confirm_delete_all_type_text": "Möchten Sie wirklich <br> alle <strong>{type}</strong> Unterdrückungen zwischen <strong>{from}</strong> und <strong>{to}</strong> löschen?",
  "suppressions_confirm_delete_filtered_label": "Vorgang bestätigen",
  "suppressions_confirm_delete_filtered_text": "Möchten Sie wirklich alle <strong>gefilterten Unterdrückungen löschen</strong>? <br><small>*Spam-Einträge werden nicht gelöscht.</small>",
  "suppressions_confirm_delete_selected_label": "Vorgang bestätigen",
  "suppressions_confirm_delete_selected_text": "Möchten Sie die gewählten Unterdrückungen wirklich löschen?",
  "suppressions_date": "Datum",
  "suppressions_delete_all": "Alle löschen",
  "suppressions_delete_selected": "Auswahl löschen",
  "suppressions_deleted": "Die Unterdrückungen werden in Kürze gelöscht.",
  "suppressions_description_empty": "Es wurden keine Einträge für den ausgewählten Zeitraum gefunden.",
  "suppressions_details_date": "Datum",
  "suppressions_details_entry": "Eintrag",
  "suppressions_details_reason": "Begründung",
  "suppressions_details_sender": "Absender",
  "suppressions_details_subject": "Betreff",
  "suppressions_details_title": "Details",
  "suppressions_details_type": "Typ",
  "suppressions_imported": "Ihre Unterdrückungen werden in Kürze importiert.",
  "suppressions_imported_partial": "{imported} / {total} Unterdrückungen werden in Kürze importiert.",
  "suppressions_include": "Einschließen",
  "suppressions_modal_confirm": "Bestätigung",
  "suppressions_not_imported": "Unterdrückungen werden nicht importiert, da die E-Mails fehlerhaft sind.",
  "suppressions_reason": "Begründung",
  "suppressions_recipient": "Empfänger",
  "suppressions_title": "Unterdrückungen",
  "suppressions_title_empty": "Keine Unterdrückungen gefunden",
  "suppressions_type": "Typ",
  "t_api": "API-Dokumentation",
  "t_knowledgebase": "Wissensbasis",
  "t_logout": "Abmelden",
  "table_dropdown_goto": "Gehe zu Seite",
  "table_dropdown_text": "{first} — {last} von {totalRecords}",
  "thursday": "Donnerstag",
  "toggle_off": "Deaktiviert",
  "toggle_on": "Aktiviert",
  "token_can_not_be_empty": "Token kann nicht leer sein",
  "token_is_missing": "Token ist nicht vorhanden",
  "tuesday": "Dienstag",
  "unlimited": "Unbegrenzt",
  "upload_add_manually": "Manuell hinzufügen",
  "upload_add_manually_description": "Kopieren Sie mehrere E-Mail-Adressen und fügen Sie sie durch eine Endlinie getrennt in das Feld unten ein. Um sich zu merken, warum Sie die Kontakte hinzugefügt haben und um zukünftige Suchen zu erleichtern, fügen Sie einen Grund für die Unterdrückung dieser Adressen hinzu.",
  "upload_add_reason": "Geben Sie einen Grund für die Unterdrückung dieser Adressen ein.",
  "upload_allowed_files": "Erlaubte Dateiformate sind csv oder txt.",
  "upload_dd_here": "Datei hierher ziehen und einfügen",
  "upload_import_from_file": "Importieren aus einer Datei",
  "upload_import_from_file_description": "Die Datei muss aus einer Spalte bestehen und alle E-Mail-Adressen enthalten, die Sie importieren möchten. Um sich zu merken, warum Sie die Kontakte hinzugefügt haben und um zukünftige Suchen zu erleichtern, fügen Sie einen Grund für die Unterdrückung dieser Adressen hinzu.",
  "warning_lang": "Das Dashboard in Ihrer Sprache ist bald verfügbar. Wenden Sie sich in der Zwischenzeit an das Support-Team, um zum alten zurückzukehren.",
  "wednesday": "Mittwoch",
  "whitelabel_agencyname": "Agenturname",
  "whitelabel_companydetails": "Firmenangaben",
  "whitelabel_description": "Wenn Sie einen Unterkonto eröffnet haben und ein offizieller turboSMTP-Reseller sind, können Sie das Produkt mit Ihrem Logo und Ihren Firmeninformationen anpassen, um den Kunden Ihr Markenimage zu vermitteln.",
  "whitelabel_footer": "Fußzeile der Agentur",
  "whitelabel_footer_description": "Fügen Sie den HTML-Code ein, der in der Fußzeile angezeigt werden soll.",
  "whitelabel_logo": "Firmenlogo",
  "whitelabel_logo_description": "Maximal zulässige Bildgröße: 472x72px",
  "whitelabel_reset_default_image": "Standardbild zurücksetzen",
  "whitelabel_upload_image": "Bild hochladen",
  "whitelabel_upload_in_progress": "Upload läuft",
  "whitelabel_website": "Webseite der Agentur",
  "wrong_credentials_specified": "Die angegebenen Anmeldeinformationen sind falsch.",
  "missing_required_parameter_amount": "Der Betrag fehlt",
  "amount_should_be_integer": "Der Betrag sollte eine ganze Zahl sein",
  "amount_should_not_be_less_than_15": "Der Betrag sollte nicht kleiner als 15 sein",
  "amount_should_not_be_higher_than_1800": "Der Betrag sollte nicht höher als 1800 sein",
  "missing_settings_required": "Einige Einstellungen sind erforderlich, bevor sie aktiviert werden können",
  "settings_apikeys_title": "API-Schlüssel",
  "settings_apikeys_description": "API-Schlüssel sind ein hochgradig sicherer Zugang, um turboSMTP-Dienste mit Ihren Anwendungen zu verbinden. Sie können diesen Zugang jederzeit sperren.",
  "settings_apikeys_slide_title": "API-Schlüssel",
  "settings_apikeys_slide_description": "API-Schlüssel verwalten. Diese Tabelle zeigt alle Ihre aktiven API-Schlüssel an. Sie können neue Schlüssel einrichten oder bestehende Schlüssel löschen, um den Zugriff zu sperren.",
  "settings_apikeys_slide_empty_title": "API-Schlüssel einrichten",
  "settings_apikeys_slide_empty_description": "API-Schlüssel bestehen aus Consumer Keys und Consumer Secret. Es handelt sich dabei um Software-Anmeldeinformationen, die es einem Programm ermöglichen, auf Ihr turboSMTP-Konto zuzugreifen, ohne Ihren Benutzernamen und Ihr Passwort zu verwenden. Sie sind hochgradig sicher und können jederzeit gesperrt werden, ohne Ihre turboSMTP-Dashboard-Anmeldedaten zu ändern.",
  "settings_apikeys_slide_add": "API-Schlüssel einrichten",
  "settings_apikeys_slide_add_description": "Wählen Sie einen Referenznamen für Ihren API-Schlüssel.",
  "settings_apikeys_apikey_name": "Name",
  "settings_apikeys_slide_label_info": "Dieser Name dient nur als Referenz. Sie müssen den Namen nicht in Ihren Anwendungen eingeben.",
  "settings_apikeys_apikey_key": "Consumer Key",
  "settings_apikeys_apikey_creationtime": "Erstellungszeit",
  "settings_apikeys_apikey_name_label": "API-Schlüssel-Name",
  "settings_apikeys_apikey_name_placeholder": "API-Schlüssel Namen vergeben",
  "settings_apikeys_apikey_revoke_alt": "Löschen & sperren",
  "settings_apikeys_apikey_confirm_revoke_label": "API-Schlüssel löschen & sperren",
  "settings_apikeys_apikey_confirm_revoke_text": "API-Schlüssel löschen \"{Name}\"?<br>Damit wird der Zugang für alle Anwendungen, die diesen Schlüssel verwenden, gesperrt.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Bestätigen ",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Abbrechen",
  "settings_apikeys_apikey_revoked": "API-Schlüssel erfolgreich gesperrt",
  "settings_apikeys_apikey_consumerkey_button_add": "API-Schlüssel erstellen",
  "settings_apikeys_apikey_new_success": "API-Schlüssel erstellt!",
  "settings_apikeys_apikey_consumer": "Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "Dieses <strong>Consumer Secret</strong> wird nur hier angezeigt. <strong>Kopieren Sie es jetzt und bewahren Sie es sicher auf</strong>. Sollten Sie diesen Schlüssel verlieren, muss er gelöscht und ein neuer Schlüssel erstellt werden.",
  "settings_apikeys_allowed_ips": "Erlaubte IPs:",
  "settings_apikeys_ips_label": "IP-Beschränkung",
  "settings_apikeys_permissions_label": "API-Berechtigungen",
  "settings_apikeys_permissions_description": "Wählen Sie aus, auf welche Dienste dieser API-Schlüssel zugreifen kann.",
  "settings_apikeys_permission_send_smtp": "SMTP-Versand",
  "settings_apikeys_permission_send_api": "HTTP-API-Versand",
  "settings_apikeys_permission_apis": "Statistiken & Management-APIs",
  "settings_apikeys_permissions_required": "Bitte wählen Sie mindestens eine Option aus",
  "settings_apikeys_legacy_key_alert_message": "Wir haben unsere <strong>SMTP-Authentifizierung</strong> aktualisiert, um <strong>API-Schlüssel</strong> anstelle Ihres Kontopassworts zu verwenden.<br>Um einen reibungslosen Übergang zu gewährleisten, <strong>haben wir einen speziellen API-Schlüssel</strong> für Sie erstellt, der mit Ihren alten Anmeldeinformationen übereinstimmt. Für verbesserte Sicherheit empfehlen wir dringend, <strong>diesen Schlüssel zu löschen und einen neuen zu erstellen</strong>, um ihn in Ihren SMTP-Einstellungen zu verwenden.",
  "settings_apikeys_legacy_key_alert_link": "Mehr Infos",
  "settings_apikeys_legacy_key_alert_link_href": "https://serversmtp.com/de/sicherheitsupdate-umstellung-auf-authentifizierung-mit-api-schlusseln/",
  "settings_apikeys_apikey_edit_alt": "API-Schlüssel bearbeiten",
  "settings_apikeys_slide_edit_description": "Bearbeiten Sie die Details des API-Schlüssels unten.",
  "settings_apikeys_apikey_updated": "API-Schlüssel erfolgreich aktualisiert",
  "settings_apikeys_apikey_consumerkey_button_save": "Änderungen speichern",
  "settings_bccs_missing_required": "Stellen Sie bitte sicher, dass Sie ein BCC als Standard festlegen, bevor Sie es aktivieren",
  "settings_bccs_notifications_default": "BCC-Standard-E-Mail erfolgreich aktualisiert",
  "settings_link_branding_enable": "Einrichtung Ihrer eigenen Track Domains aktivieren",
  "settings_link_branding_missing_required": "Vor der Aktivierung mindestens eine Domain hinzufügen und verifizieren",
  "settings_link_branding_title": "Eigene Track Domains",
  "settings_link_branding_description": "Verwenden Sie Ihre eigenen Domains für Open- und Click-Tracking anstelle von turboSMTP-Domains.",
  "settings_link_branding_box_alert": "Diese Einstellungen werden nicht wirksam, wenn Open Tracking und Click Tracking deaktiviert sind.",
  "settings_link_branding_empty_description": "Klicken Sie auf \"Add Domain\" und tragen Sie die erforderlichen Informationen in die Felder ein...",
  "settings_link_branding_empty_title": "Track Domain hinzufügen",
  "settings_link_branding_add_domain": "Track Domain hinzufügen",
  "settings_link_branding_add_domain_info": "Geben Sie Ihre Domain ein und ändern Sie eventuelle zusätzliche Einstellungen.",
  "settings_link_branding_advanced": "Erweiterte Optionen",
  "settings_link_branding_custom_subdomain": "Eigene Subdomain",
  "settings_link_branding_custom_subdomain_tooltip": "Bitte geben Sie einen gültigen Domainnamen ein, bevor Sie eine eigene Subdomain festlegen.",
  "settings_link_branding_custom_subdomain_info": "Das System wird eine zufällige Subdomain generieren. Wenn Sie eine spezifische Subdomain verwenden möchten, geben Sie diese hier ein.",
  "settings_link_branding_button_add": "Track Domain hinzufügen",
  "settings_link_branding_match": "Track Domain mit Absenderdomain abgleichen",
  "settings_link_branding_match_sender_disabled": "Domainabgleichung deaktiviert",
  "settings_link_branding_match_sender_enabled": "Domainabgleichung aktiviert",
  "settings_link_branding_filters_no_results": "Keine Einträge mit diesen Filtern gefunden",
  "settings_link_branding_search_placeholder": "Track Domains nach Namen filtern...",
  "settings_link_branding_verification_placeholder": "Verifizierung...",
  "settings_link_branding_verified": "Verifiziert",
  "settings_link_branding_click_to_verify": "PENDING. Die CNAME-Konfiguration für diese Domain wurde noch nicht abgeschlossen oder verifiziert. Zum Fortfahren hier klicken...",
  "settings_link_branding_verification_success": "Verifizierung erfolgreich",
  "settings_link_branding_verification_domain_not_found": "Domain nicht gefunden",
  "settings_link_branding_verification_cname_not_found": "Die Subdomain {track_dns} CNAME wurde nicht gefunden",
  "settings_link_branding_verification_auth_cname_not_found": "Die Subdomain {auth_dns} CNAME wurde nicht gefunden",
  "settings_link_branding_verification_multiple_cname_found": "Es wurden mehrere CNAME-Einträge für die Subdomain {track_dns} gefunden",
  "settings_link_branding_verification_auth_multiple_cname_found": "Es wurden mehrere CNAME-Einträge für die Subdomain {auth_dns} gefunden",
  "settings_link_branding_verification_incorrect_cname_target": "Der CNAME der Subdomain {track_dns} enthält einen inkorrekten Wert",
  "settings_link_branding_verification_auth_incorrect_cname_target": "Der CNAME der Subdomain {auth_dns} enthält einen inkorrekten Wert",
  "settings_link_branding_enabled": "Aktiviert",
  "settings_link_branding_disabled": "Deaktiviert",
  "settings_link_branding_not_verified": "Pending",
  "settings_link_branding_name": "Domainname",
  "settings_link_branding_enabled_no": "Track Domain deaktiviert",
  "settings_link_branding_enabled_yes": "Track Domain aktiviert",
  "settings_link_branding_default_enabled": "Track Domain als nicht dedicated gesetzt",
  "settings_link_branding_default_disabled": "Track Domain als dedicated gesetzt",
  "settings_link_branding_subdomain_name_invalid": "Subdomain ist ungültig",
  "settings_link_branding_domain_name_invalid": "Ungültiger Domainname",
  "settings_link_branding_confirm_delete_label": "Track Domain löschen",
  "settings_link_branding_confirm_delete_text": "Möchten Sie diese Track Domain wirklich löschen?",
  "invalid_domain_name": "Ungültiger Domainname angegeben",
  "settings_link_branding_exclusivity_placeholder": "Wurde dedicated...",
  "settings_link_branding_exclusive": "Dedicated",
  "settings_link_branding_not_exclusive": "Nicht dedicated",
  "settings_link_branding_domain_name": "Track Domain",
  "settings_link_branding_domain_status": "Status",
  "settings_link_branding_added": "Domain erfolgreich hinzugefügt",
  "settings_link_branding_removed": "Domain erfolgreich entfernt",
  "settings_link_branding_default_match_help": "Dedicated Domains werden nur mit übereinstimmenden Absenderdomains verwendet. Keinesfalls werden sie mit nicht übereinstimmenden Absenderdomains verwendet.",
  "settings_link_branding_dns_info": "Um den Vorgang abzuschließen, müssen Sie die folgenden Einträge installieren.",
  "settings_link_branding_ssl_verify": "Wir können nicht überprüfen, ob Ihre SSL-Domains vom Dashboard aus korrekt eingerichtet sind. Wenn Sie Hilfe benötigen, wenden Sie sich bitte an unser technisches Support-Team.",
  "settings_link_branding_dns_wait": "Es kann bis zu 24 Stunden dauern, bis Änderungen an DNS-Einträgen wirksam werden",
  "settings_link_branding_dns_info_host": "Fügen Sie diese beiden Einträge in den DNS-Bereich Ihres Hosts ein.",
  "settings_link_branding_dns_type": "Typ",
  "settings_link_branding_dns_host": "Host",
  "settings_link_branding_dns_host_help": "Bei einigen DNS-Hosts wird dies möglicherweise als  \"Domain\" oder \"Name\"bezeichnet.",
  "settings_link_branding_dns_value": "Wert",
  "settings_link_branding_dns_value_help": "Einige DNS-Hosts bezeichnen dies als \"Data\".",
  "settings_link_branding_dns_help": "Nicht sicher, wie man das macht?",
  "settings_link_branding_dns_help_link": "Bitte informieren Sie sich anhand der Dokumentation",
  "settings_link_branding_dns_verification_tooltip": "Dieser CNAME-Eintrag ist für alle Subdomains der Domain gleich. Er sollte nur einmal hinzugefügt werden: Wenn er bereits vorhanden ist, muss er nicht hinzugefügt werden.",
  "settings_link_branding_verify_description": "Klicken Sie nach dem Hinzufügen auf Verifizieren.",
  "settings_link_branding_verify_button": "Verifizieren",
  "settings_link_branding_delete_info": "Sie benötigen diese Track Domain nicht mehr?",
  "settings_link_branding_delete_button": "Track Domain löschen",
  "settings_link_branding_security_placeholder": "Sicherheit...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Ok",
  "settings_link_branding_status_placeholder": "Status...",
  "settings_link_branding_status_enabled_no": "Deaktiviert",
  "settings_link_branding_status_enabled_yes": "Aktiv",
  "settings_link_branding_all_domains_disabled": "Wenn alle eigenen Domains deaktiviert oder pending sind, werden turboSMTP-Tracking-Links verwendet.",
  "settings_link_branding_no_default_domain": "Wenn alle aktiven Tracking Links auf \"Dedicated\" gesetzt werden, verwenden Absender mit deaktivierten oder fehlenden Domains in dieser Liste stattdessen unsere turboSMTP-Tracking-Links.",
  "settings_link_branding_match_modal_cancel": "Abbrechen",
  "settings_link_branding_match_modal_confirm": "Ok",
  "settings_link_branding_match_title": "Domain-Rotation",
  "settings_link_branding_match_change": "Dieses Verhalten ändern",
  "settings_link_branding_match_enabled_title": "Absenderdomain abgleichen",
  "settings_link_branding_match_disabled_title": "Absenderdomain nicht abgleichen",
  "settings_link_branding_match_enabled_info": "Falls die Absenderdomain mit einer der aktiven Track Domains übereinstimmt, wird diese Track Domain verwendet. <br> Falls die Absenderdomain mit keiner Track Domain übereinstimmt, wird eine der aktiven Track Domains (außer \"Dedicated\") zufällig verwendet.",
  "settings_link_branding_match_disabled_info": "Alle aktiven Track Domains werden unabhängig von der Absenderdomain verwendet.",
  "config_server_error": "Das Dashboard wird gerade gewartet, bitte versuchen Sie es in ein paar Minuten erneut",
  "feature_not_available_for_active_plan": "Diese Funktion ist in keinem Ihrer Pläne enthalten",
  "forgot_password_use_different_password": "Bitte erstellen Sie ein neues Passwort, das sich von Ihren bisherigen Passwörtern unterscheidet, um die Sicherheit Ihres Kontos zu erhöhen.",
  "m_getting_started": "Startseite",
  "settings_sender_title": "Überprüfung der Absenderdomain",
  "settings_sender_add_domain": "Domain hinzufügen",
  "settings_sender_description": "Zur Verbesserung Ihrer E-Mail-Zustellung authentifizieren Sie Ihre Absenderdomain einfach mit drei wichtigen DNS-Einträgen.",
  "settings_sender_domains_empty": "Es gibt noch keine verifizierten Absenderdomains.<br>Bitte verifizieren Sie Ihre erste Domain.",
  "settings_sender_if_unverified": "Was passiert, wenn die Absenderdomain nicht verifiziert ist?",
  "settings_sender_notify_label": "Benachrichtigen Sie mich per E-Mail, wenn die Absenderdomain nicht verifiziert ist",
  "settings_sender_notify_email_label": "E-Mail Adresse",
  "settings_sender_notify_email_tip": "Wenn leer, wird die Benachrichtigungs-E-Mail an die turboSMTP-Kontoadresse gesendet.",
  "settings_sender_notify_email_error": "Bitte geben Sie eine gültige E-Mail Adresse ein",
  "settings_sender_notify_email_placeholder": "Geben Sie eine E-Mail Adresse ein...",
  "settings_sender_dns_title": "So verifizieren Sie Ihre Domain",
  "settings_sender_dns_description": "Für unseren SMTP-Service müssen Sie SPF- und DKIM-Einträge für Ihre Absenderdomains einrichten. Das Hinzufügen eines DMARC-Eintrags ist für eine verbesserte E-Mail-Sicherheit und -Zustellbarkeit ebenfalls erforderlich.",
  "settings_sender_spf_title": "SPF-Eintrag",
  "settings_sender_spf_description": "Bitte fügen Sie den angegebenen TXT-Eintrag an die Absenderdomain an und wählen Sie eine der beiden folgenden Alternativen aus:",
  "settings_sender_dkim_title": "DKIM-Eintrag",
  "settings_sender_dkim_description": "Für DKIM fügen Sie den bereitgestellten TXT-Eintrag zu den DNS-Einstellungen Ihrer Domain hinzu, der den öffentlichen Schlüssel zur Verifizierung der Rechtmäßigkeit und Authentizität der von Ihrer Domain gesendeten E-Mails enthält.",
  "settings_sender_dmarc_title": "DMARC-Eintrag",
  "settings_sender_dmarc_description": "Vervollständigen Sie den E-Mail-Authentifizierungsprozess, indem Sie den angegebenen DMARC-TXT-Eintrag zu Ihrem DNS hinzufügen. Damit legen Sie eine Richtlinie fest, wie E-Mail-Empfänger Nachrichten behandeln sollen, die die SPF- oder DKIM-Prüfungen nicht bestehen, und bieten so eine zusätzliche Sicherheitsebene gegen betrügerische E-Mail-Praktiken.",
  "settings_sender_domain_added": "Absenderdomain <strong>{domain}</strong> hinzugefügt.",
  "settings_sender_domain": "Absenderdomain",
  "settings_sender_domains_name": "Domain-Name",
  "settings_sender_domains_action_verify": "Überprüfen",
  "settings_sender_domains_action_delete": "Löschen",
  "settings_sender_domains_action_subaccount": "Unterkonto:",
  "settings_sender_action_delete_confirm_title": "Domain löschen",
  "settings_sender_action_delete_confirm_message": "Sind Sie sicher, dass Sie die Domain <strong>{DomainName}</strong> löschen möchten?",
  "settings_sender_domain_description": "Geben Sie die Domain des Absenders an, die Sie bestätigen möchten:",
  "settings_sender_verify_record": "TXT-Eintrag",
  "settings_sender_verify_value": "Status",
  "settings_sender_verify_ok": "Ok",
  "settings_sender_dns_ask_admin": "Bitte wenden Sie sich an Ihren Kundenbetreuer, um die Domain zu überprüfen. Diese Maßnahme ist erforderlich und kann nur vom Hauptkontoinhaber durchgeführt werden.",
  "settings_sender_verify_fail": "{type} nicht gefunden oder nicht richtig konfiguriert",
  "settings_sender_verified": "Ihre Domain ist ordnungsgemäß konfiguriert. Sie können sicher mit diesem Absender senden.",
  "settings_sender_dkim_domain_title": "DKIM-Domain",
  "settings_sender_dkim_value_title": "DKIM-Wert",
  "settings_sender_dmarc_domain_title": "DMARC-Domain",
  "settings_sender_dmarc_value_title": "DMARC-Wert",
  "settings_sender_domains_search_placeholder": "Absenderdomains nach Namen filtern...",
  "settings_sender_domains_status_placeholder": "Verifizierung...",
  "settings_sender_domains_status_verified": "Verifiziert",
  "settings_sender_domains_status_not_verified": "Nicht verifiziert",
  "settings_sender_domains_filters_no_results": "Keine Einträge mit diesen Filtern gefunden",
  "block_unverified_sender_title": "Nicht verifizierte Absenderdomains blockieren",
  "block_unverified_sender_modal_title": "Nicht verifizierte Absenderdomains",
  "block_unverified_sender_desc": "Falls die Absenderdomain nicht verifiziert ist, den E-Mail-Versand blockieren und mich per E-Mail benachrichtigen",
  "block_unverified_sender_change": "Dieses Verhalten ändern",
  "forward_as_received_title": "Ohne Änderungen senden",
  "forward_as_received_info": "E-Mails ohne Änderungen versenden, auch von unverifizierten Absenderdomains. Beachten Sie, dass dies wahrscheinlich zu einer <strong>hohen Bounce-Rate und einer geringen Zustellbarkeit</strong> führt, da Ihre E-Mails als Spam gekennzeichnet werden könnten, was wiederum den Ruf Ihrer Domain beeinträchtigt.",
  "block_title": "Ablehnen und verwerfen",
  "block_info": "Wählen Sie diese Option, um sicherzustellen, dass E-Mails von nicht verifizierten Absenderdomains nicht versendet werden. Nachrichten, die SPF-, DKIM- oder DMARC-Prüfungen nicht bestehen, werden automatisch verworfen, um Ihren <strong>Ruf als Absender zu wahren</strong> und das Risiko zu vermeiden, als Spam markiert zu werden.",
  "fallback_to_turbo_title": "Neuer Absender-Umschlag",
  "fallback_to_turbo_info": "Wählen Sie diese Option, um eine turboSMTP-Adresse als Absender für E-Mails von nicht verifizierten Absenderdomains zu verwenden. Dies kann die Zustellbarkeit verbessern, obwohl die <strong>Änderung der Absenderadresse</strong> von den Empfängern in ihren E-Mail-Clients bemerkt werden könnte.",
  "notification_email_updated": "Benachrichtigungsmail aktualisiert.",
  "notification_email_enabled": "Benachrichtigungsmail aktiviert.",
  "notification_email_disabled": "Benachrichtigungsmail deaktiviert.",
  "invalid_notification_email": "Angegebene Benachrichtigungsmail ungültig",
  "settings_sender_domains_new_intro": "Neue Domaininformationen eingeben",
  "paginator_page": "Seite",
  "paginator_of": "von",
  "no_records_found": "DNS-Eintrag nicht gefunden. Stellen Sie sicher, dass der Eintrag korrekt veröffentlicht ist und die Verbreitung abgeschlossen ist.",
  "invalid_record_found": "Ein DNS-Eintrag wurde gefunden, scheint aber fehlerhaft formatiert zu sein oder einen ungültigen Wert zu haben.",
  "too_many_dns_lookups": "Der SPF-Eintrag enthält mehr als das erlaubte Limit von 10 DNS-Anfragen, was zu Problemen bei der E-Mail-Zustellung führen kann.",
  "more_than_spf_entry_found": "Mehrere SPF-Einträge wurden für Ihre Domain erkannt. Es ist nur ein einzelner SPF-Eintrag pro Domain zulässig.",
  "settings_sender_loading_domain_data": "Laden der Domain-Überprüfungsergebnisse...",
  "notice": "Achtung",
  "settings_sender_domains_no_option": "<p>Ihr Konto arbeitet derzeit im \"Standard mode\", einer <strong>älteren Konfiguration</strong>, die alle ausgehenden E-Mails mit unserer E-Mail-Adresse neu verpackt, unabhängig von Ihren SPF-, DKIM- und DMARC-Einstellungen.</p>\n<p>Um die Zustellbarkeit von E-Mails zu verbessern, empfehlen wir dringend, eine der aktualisierten Ausfalloptionen zu wählen.</p>",
  "failed_to_get_a_aaaa_record": "Fehler beim Abrufen von A / AAAA-Datensätzen für {domain_name}",
  "invalid_spf_syntax": "Ungültige SPF-Syntax",
  "spf_has_upper_case_letters": "Der SPF-Eintrag darf keine Großbuchstaben enthalten. Bitte stellen Sie sicher, dass alle Buchstaben klein geschrieben sind, um den SPF-Vorgaben zu entsprechen.",
  "recursive_include_detected": "Ihr SPF-Eintrag sollte die Domain selbst nicht einschließen, da dies zu einer Schleife führt, die unendliche DNS-Anfragen zur Folge hat. Bitte überarbeiten Sie den SPF-Eintrag, um die Domain-Referenz zu entfernen, um zirkuläre Abhängigkeiten zu vermeiden und den SPF-Vorgaben zu entsprechen.",
  "spf_longer_than_255_characters": "Der SPF-Eintrag überschreitet das Limit von 255 Zeichen für eine einzelne DNS-Textzeichenkette. Um den DNS-Spezifikationen zu genügen, teilen Sie bitte Ihren SPF-Eintrag in mehrere Zeichenketten, die jeweils nicht länger als 255 Zeichen sind, oder kürzen Sie den Eintrag, um das Limit einzuhalten.",
  "ptr_mechanism_not_allowed": "Um die Leistung von SPF zu optimieren und die Übernahme robuster Absender-Verifizierungspraktiken zu fördern, ist es ratsam, den ptr-Mechanismus auszuschließen und stattdessen auf Mechanismen wie ip4 und include zu verlassen.",
  "data_location_modal_title": "Datenstandort",
  "data_location_network_servers": "Netzwerkserver",
  "data_location_ip_location": "IP-Standort",
  "data_location_company_managing_data": "Datenverwaltende Firma",
  "data_location_network_servers_value": "Mailand (IT), Frankfurt (DE), Amsterdam (NL)",
  "data_location_ip_location_value": "Europa RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Italien EU",
  "data_location_no_transfer_outside_eu": "Keine Datenübertragung außerhalb der Europäischen Union",
  "gdpr_data_location": "Daten in EU",
  "gdpr_see_details": "Details",
  "not_included_in_plan": "Nicht in Ihrem aktuellen Plan enthalten",
  "registration_logout": "Abmelden",
  "registration_step_personal": "Persönliche Daten",
  "registration_step_company": "Firmendaten",
  "registration_step_address": "Adresse",
  "registration_label_email": "E-Mail",
  "registration_label_firstname": "Vorname",
  "registration_label_lastname": "Nachname",
  "registration_label_company": "Firma",
  "registration_label_vat": "Umsatzsteuer-ID",
  "registration_label_vat_optional": "(Optional)",
  "registration_label_phone": "Telefonnummer",
  "registration_label_website": "Website",
  "registration_label_website_hint": "(Optional)",
  "registration_label_address": "Adresse",
  "registration_label_city": "Stadt",
  "registration_label_country": "Land",
  "registration_placeholder_country": "Land auswählen",
  "registration_label_region": "Bundesland / Region",
  "registration_placeholder_region": "Region auswählen",
  "registration_label_zip": "Postleitzahl",
  "registration_btn_back": "Zurück",
  "registration_btn_next": "Nächster Schritt",
  "registration_btn_complete": "Profil vervollständigen",
  "registration_error_firstname": "Vorname ist erforderlich.",
  "registration_error_lastname": "Nachname ist erforderlich.",
  "registration_error_company": "Firma ist erforderlich.",
  "registration_error_phone": "Telefonnummer ist erforderlich.",
  "registration_error_website": "Bitte geben Sie eine gültige URL ein.",
  "registration_error_address": "Adresse ist erforderlich.",
  "registration_error_city": "Stadt ist erforderlich.",
  "registration_error_country": "Land ist erforderlich.",
  "registration_error_region": "Region ist erforderlich.",
  "registration_error_zip": "Postleitzahl ist erforderlich.",
  "registration_error_phone_format": "Die Telefonnummer darf nur Ziffern enthalten.",
  "registration_address_message": "Wenn Sie sicherstellen, dass Ihre Postanschrift korrekt ist, können Sie von einer <strong>beschleunigten Aktivierung</strong> profitieren.",
  "registration_step_confirmation": "Bestätigung",
  "registration_confirmation_title": "Profil vervollständigt!",
  "registration_confirmation_message": "Ihr Konto wurde erfolgreich erstellt.<br>Sie können jetzt ein Abonnement erwerben, um erweiterte Funktionen und höhere Sendelimits freizuschalten",
  "registration_confirmation_message_buy": "Ihr Konto wurde erfolgreich erstellt.",
  "registration_btn_buy_plan": "Plan kaufen",
  "registration_stay_free": "Die kostenlose Version behalten, später upgraden",
  "registration_btn_dashboard": "Zum Dashboard",
  "registration_redirect_to_shop": "Sie werden in Kürze zum Bezahlvorgang weitergeleitet...",
  "registration_go_to_shop": "Klicken Sie hier, um zur Kasse zu gehen",
  "button_yes_delete": "Ja, löschen",
  "button_yes_revoke": "Ja, widerrufen"
}
